module.exports = __webpack_public_path__ + "static/media/zoom.2216e740.svg";